/**
 * @file Entry HTML: chỉ `import("./bootstrap")` (code-split). **Step 1/6** tại đây; các bước tiếp trong {@link ./bootstrap}.
 *
 * @example Lỗi network/chunk: `console` + `[Boot]` + `alert` (stack nếu là `Error`).
 */
import { bootLogger } from "./utils/logger";

bootLogger.info("Step 1/6: HTML entry → dynamic import(bootstrap chunk)");

import("./bootstrap")
  .catch((err: unknown) => {
    bootLogger.error("Step 1/6: bootstrap chunk failed to load or execute", err);
    alert(err instanceof Error ? err.stack?.trim() || err.message : String(err));
  });
